/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../js/global";
	import * as helper from "../../js/helper";
	import full_loading from "../components/full-loading.vue";
	import search_filters_modal from "../modal/search-filters-modal.vue";
	import property_component from "../components/property-component.vue";
	import filter_tablets_component from "../components/filter-tablets-component.vue";
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
            property_component:property_component,
            search_filters_modal:search_filters_modal,
            filter_tablets_component:filter_tablets_component,
        },
		name:'user_catalogue_widget',
        props: {
            user_id: {
                type: String,
                default: null
            },
            mashro_data: {
                type: String,
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                search_filters:localStorage.user_catalogue_search_filters?JSON.parse(localStorage.user_catalogue_search_filters):global.search_filters,
                is_ready:false,
                is_loading:false,
				mashro: null,
                page: 0,
                map: null,
                map_marker: null,
                mapsLayerGroup: null,
                marker_popup: null,
				properties: [],
			}
		},
        mounted(){
            this.mashro = JSON.parse(this.mashro_data);
            this.is_ready = true;
            
            this.setup_things();
            this.load_data();
            setTimeout(async ()=>{
                var navText = [
                        "<i class='ri-arrow-left-line'></i>",
                        "<i class='ri-arrow-right-line'></i>",
                ];
                if(frappe.lang_dir == "rtl"){
                    navText = [
                        "<i class='ri-arrow-right-line'></i>",
                        "<i class='ri-arrow-left-line'></i>",
                    ];
                }
                $('#discover-slide').owlCarousel({
                    items: 3,
                    loop: false,
                    rtl: frappe.lang_dir == "rtl",
                    margin: 10,
                    nav: true,
                    dots: false,
                    autoplay: true,
                    smartSpeed: 1000,
                    autoplayHoverPause: true,
                    navText: navText,
                    responsive: {
                        0: {
                            items: 2,
                        },
                        576: {
                            items: 3,
                        },
                        768: {
                            items: 3,
                        },
                        992: {
                            items: 4,
                        },
                        1200: {
                            items: 4,
                        },
                    },
                });
                $('.gallery-popup').each(function() {
                    $(this).magnificPopup({
                        delegate: 'a.gallery-image', 
                        type: 'image',
                        gallery: {
                            enabled:true
                        }
                    });
                });

                $('.popup-youtube, .popup-vimeo').magnificPopup({
                    disableOn: 300,
                    type: 'iframe',
                    mainClass: 'mfp-fade',
                    removalDelay: 160,
                    preloader: false,
                    fixedContentPos: false,
                });
            }, 500);
        },
        unmounted(){
            window.removeEventListener("scroll",this.handleScroll);
        },
		methods: {
            setup_things: async function () {
                var initial_lat = this.mashro.lat; 
                var initial_lng = this.mashro.lng;
                let corner1 = L.latLng(31.896210012370656, 33.96066018865814);
                let corner2 = L.latLng(17.613607036429755, 55.8301100044458);
                var google_street_layer = L.tileLayer(
                    "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
                    {
                        maxZoom: 18,
                        minZoom: 6,
                        subdomains: ["mt0", "mt1", "mt2", "mt3"],
                        attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
                    }
                );
                var google_satellite_layer = L.tileLayer(
                    "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
                    {
                        maxZoom: 18,
                        minZoom: 6,
                        subdomains: ["mt0", "mt1", "mt2", "mt3"],
                        attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
                    }
                );
                var open_street = L.tileLayer(
                    "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
                    {
                        maxZoom: 18,
                        minZoom: 6,
                        attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
                    }
                );
                this.mapsLayerGroup = new L.LayerGroup();
                this.markerLayerGroup = new L.LayerGroup();
                this.map = L.map("map", {
                    center: [initial_lat, initial_lng],
                    zoom: 15,
                    maxZoom: 18,
                    minZoom: 10,
                    dragging: false,
                    maxBounds: L.latLngBounds(corner1, corner2),
                    layers: [
                        this.mapsLayerGroup,
                        this.markerLayerGroup,
                    ],
                });
                this.map.scrollWheelZoom.disable();
                this.mapsLayerGroup.addLayer(open_street);

                // this.map_marker = L.marker([initial_lat, initial_lng]);
                // this.markerLayerGroup.addLayer(this.map_marker);
                var baseLayers = frappe.lang_dir=='ltr'?{
                    "Map 1": open_street,
                    "Map 2": google_street_layer,
                    "Satellite": google_satellite_layer,
                }:{
                    "الخريطة 1": open_street,
                    "الخريطة 2": google_street_layer,
                    "القمر الصناعي": google_satellite_layer,
                };
                var layerControl = L.control.layers(baseLayers).addTo(this.map);
                latlng = L.latLng(initial_lat, initial_lng)

                var geo_json = JSON.parse(this.mashro.location);
                var polygon = L.geoJSON(geo_json,{
                    onEachFeature:function (feature, layer) {
                    }
                }).on("click", (e) => {
                    window.open("/project/"+mashro["name"],"_blank");
                });
                this.mashro["marker"] = polygon
                this.mashro["marker"]["mashro"] = this.mashro;
                this.mashro["marker"].addTo(this.map);

            },
            
            check_local_storage: async function(){
                this.page = await localStorage.my_catalogue_page?localStorage.my_catalogue_page:0;
                this.end_of_page = localStorage.my_catalogue_end_of_page == 1?true:false;
                this.properties = localStorage.my_catalogue_records?JSON.parse(localStorage.my_catalogue_records):[];
                this.$forceUpdate(); 
            },
            load_data: async function(reload=false){
                if(this.is_loading)
                    return;
                if(reload){
                    this.page = 0;
                    this.end_of_page = false;
                    while(this.properties.length > 0) {
                        this.properties.pop();
                    }
                }
                if(this.end_of_page)
                    return;
                global.emitter.emit("show-full-loading");
                this.is_loading = true;
                let params = {
                    'mashro_id': this.mashro.name,
                    "filters":JSON.stringify(this.search_filters),
                    "page":this.page
                };
                let url = "/api/method/maalek.api.mashro_catalogue";
                let res = await $.ajax({
                    url: url,
                    type: "GET",
                    data: params
                });
                if(res.message.length > 0){
                    for (let index = 0; index < res.message.length; index++) {
                        this.properties.push(res.message[index]);
                    }
                    this.page++;
                }else{
                    this.end_of_page = 1;
                }
                localStorage.my_catalogue_records = JSON.stringify(this.properties);
                localStorage.user_catalogue_search_filters = JSON.stringify(this.search_filters);
                localStorage.my_catalogue_page = this.page;
                localStorage.my_catalogue_end_of_page = this.end_of_page?1:0;
                this.is_loading = false;
                global.emitter.emit("hide-full-loading");
            },
            handleScroll: function (){
                if(this.end_of_page){
                    window.removeEventListener("scroll",this.handleScroll);
                }
                if(this.loading || this.end_of_page)
                    return;
                let pagination_component = this.$refs["pagination_component"];
                if (pagination_component.getBoundingClientRect().bottom < window.innerHeight) {
                    this.load_data();
                }
            }
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-listing" },
    [
      _c("full_loading"),
      _vm._v(" "),
      _vm.is_ready
        ? _c(
            "div",
            { staticClass: "section-card p-2" },
            [
              _vm.mashro["images"].length
                ? [
                    _c("div", { staticClass: "gap-mb-20" }),
                    _vm._v(" "),
                    _c("h3", [_vm._v(_vm._s(_vm.helper.t("Project Gallery")))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "discover-area gallery-popup pv-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "owl-carousel owl-theme",
                            attrs: { id: "discover-slide" }
                          },
                          [
                            _vm.mashro["video"]
                              ? _c("div", { staticClass: "single-discover" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "single-gallery background-image",
                                      staticStyle: { color: "RED" },
                                      style: {
                                        "background-image":
                                          "url(" +
                                          ("https://img.youtube.com/vi/" +
                                            _vm.mashro["video_code"] +
                                            "/maxresdefault.jpg") +
                                          ")"
                                      }
                                    },
                                    [
                                      false
                                        ? _c("img", {
                                            attrs: {
                                              src:
                                                "https://img.youtube.com/vi/" +
                                                _vm.mashro["video_code"] +
                                                "/maxresdefault.jpg",
                                              alt: "Image"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "ri-play-fill fa-2xl",
                                        staticStyle: {
                                          position: "absolute",
                                          top: "50%",
                                          right: "50%",
                                          transform: "translate(50%, -50%)"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "video-button" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "popup-youtube",
                                              attrs: {
                                                href:
                                                  "https://www.youtube.com/watch?v=" +
                                                  _vm.mashro["video_code"],
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "ri-play-fill"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.mashro["images"], function(
                              mashro_image
                            ) {
                              return _c(
                                "div",
                                { staticClass: "single-discover" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "single-gallery background-image",
                                      staticStyle: { color: "RED" },
                                      style: {
                                        "background-image":
                                          "url(/" +
                                          encodeURIComponent(
                                            mashro_image.substr(1)
                                          ) +
                                          ")"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "gallery-image",
                                          attrs: {
                                            href: mashro_image,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "ri-eye-line"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.is_ready
        ? _c(
            "div",
            { ref: "pagination_component", staticClass: "row pt-3" },
            [
              (_vm.frappe.user_roles.includes("Member") ||
                _vm.frappe.user_roles.includes("Developer")) &&
              (_vm.mashro["managed"] || _vm.mashro["owned"])
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-start align-items-start g-0 text-start"
                    },
                    [
                      _c("h3", [_vm._v(_vm._s(_vm.helper.t("Units")))]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn default-btn ms-auto",
                          attrs: {
                            href:
                              "/account/add-property?mashro=" +
                              _vm.mashro["name"],
                            target: "_blank"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa-solid fa-plus" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.helper.t("Add Unit")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.properties, function(property) {
                return _c(
                  "div",
                  { staticClass: "col-xl-3 col-lg-4" },
                  [
                    _c("property_component", {
                      attrs: { property: property, for_mashro: true }
                    })
                  ],
                  1
                )
              }),
              _vm._v(" "),
              !_vm.is_loading && _vm.properties.length == 0
                ? _c("h5", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.helper.t("No unit to show!")))
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row map-location" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "position-relative section-card" }, [
          _c("div", { staticStyle: { height: "500px" }, attrs: { id: "map" } })
        ])
      ])
    ])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-33215839_0", { source: "\n#discover-slide.owl-theme .owl-nav {\n    position: unset;\n    top: -92px;\n    right: -5px;\n    margin-top: 0;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/widgets/single-mashro-widget.vue"],"names":[],"mappings":";AA+TA;IACA,eAAA;IACA,UAAA;IACA,WAAA;IACA,aAAA;AACA","file":"single-mashro-widget.vue","sourcesContent":["<template>\r\n    <div class=\"my-listing\">\r\n        <full_loading></full_loading>\r\n        <div v-if=\"is_ready\" class=\"section-card p-2\">\r\n            <!-- Start Discover Area -->\r\n            <template v-if=\"mashro['images'].length\">\r\n                <div class=\"gap-mb-20\"></div>\r\n                <h3>{{ helper.t(\"Project Gallery\") }}</h3>\r\n                <div class=\"discover-area gallery-popup pv-3\">\r\n                    <div id=\"discover-slide\" class=\"owl-carousel owl-theme\">\r\n                        <div v-if=\"mashro['video']\"  class=\"single-discover\">\r\n                            <div class=\"single-gallery background-image\" \r\n                                :style=\"{ 'background-image': `url(${'https://img.youtube.com/vi/'+mashro['video_code']+'/maxresdefault.jpg'})` }\"\r\n                                style=\"color:RED;\">\r\n                                <img v-if=\"false\" :src=\"'https://img.youtube.com/vi/'+mashro['video_code']+'/maxresdefault.jpg'\" alt=\"Image\">\r\n                                <i class=\"ri-play-fill fa-2xl\" style=\"\r\n                                    position: absolute;\r\n                                    top: 50%;\r\n                                    right: 50%;\r\n                                    transform: translate(50%, -50%);\r\n                                \"></i>\r\n                                <div class=\"video-button\">\r\n                                    <a :href=\"'https://www.youtube.com/watch?v='+mashro['video_code']\" target=\"_blank\" class=\"popup-youtube\">\r\n                                        <i class=\"ri-play-fill\"></i>\r\n                                    </a>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div  v-for=\"mashro_image in mashro['images']\" class=\"single-discover\">\r\n                            <div class=\"single-gallery background-image\" \r\n                                :style=\"{ 'background-image': `url(/${encodeURIComponent(mashro_image.substr(1))})` }\"\r\n                                style=\"color:RED;\">\r\n                                <a\r\n                                    class=\"gallery-image\"\r\n                                    :href=\"mashro_image\" target=\"_blank\">\r\n                                    <i class=\"ri-eye-line\"></i>\r\n                                </a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </template>\r\n        </div>\r\n        <div class=\"row map-location\">\r\n            <div class=\"col\">\r\n                <div class=\"position-relative section-card\">\r\n                    <div id=\"map\" style=\"height: 500px;\"></div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div v-if=\"is_ready\" class=\"row pt-3\" ref=\"pagination_component\">\r\n            <div v-if=\"(frappe.user_roles.includes('Member') || frappe.user_roles.includes('Developer')) && (mashro['managed'] || mashro['owned'])\" class=\"d-flex justify-content-start align-items-start g-0 text-start\">\r\n                <h3>{{ helper.t(\"Units\") }}</h3>\r\n\t\t\t\t<a :href=\"'/account/add-property?mashro='+mashro['name']\" target=\"_blank\" class=\"btn default-btn ms-auto\">\r\n\t\t\t\t\t<i class=\"fa-solid fa-plus\"></i> {{ helper.t(\"Add Unit\") }}\r\n\t\t\t\t</a>\r\n            </div>\r\n            <div v-for=\"property in properties\" class=\"col-xl-3 col-lg-4\">\r\n                <property_component\r\n                    :property=\"property\"\r\n                    :for_mashro=\"true\"\r\n                ></property_component>\r\n            </div>\r\n            <h5 v-if=\"!is_loading && properties.length == 0\" class=\"text-center\">{{ helper.t(\"No unit to show!\") }}</h5>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\n\timport * as global from \"../../js/global\";\r\n\timport * as helper from \"../../js/helper\";\r\n\timport full_loading from \"../components/full-loading.vue\";\r\n\timport search_filters_modal from \"../modal/search-filters-modal.vue\";\r\n\timport property_component from \"../components/property-component.vue\";\r\n\timport filter_tablets_component from \"../components/filter-tablets-component.vue\";\r\n\texport default{\r\n        components: {\r\n            full_loading:full_loading,\r\n            property_component:property_component,\r\n            search_filters_modal:search_filters_modal,\r\n            filter_tablets_component:filter_tablets_component,\r\n        },\r\n\t\tname:'user_catalogue_widget',\r\n        props: {\r\n            user_id: {\r\n                type: String,\r\n                default: null\r\n            },\r\n            mashro_data: {\r\n                type: String,\r\n            },\r\n        },\r\n\t\tdata() {\r\n\t\t\treturn {\r\n                global,\r\n                helper,\r\n                frappe,\r\n                search_filters:localStorage.user_catalogue_search_filters?JSON.parse(localStorage.user_catalogue_search_filters):global.search_filters,\r\n                is_ready:false,\r\n                is_loading:false,\r\n\t\t\t\tmashro: null,\r\n                page: 0,\r\n                map: null,\r\n                map_marker: null,\r\n                mapsLayerGroup: null,\r\n                marker_popup: null,\r\n\t\t\t\tproperties: [],\r\n\t\t\t}\r\n\t\t},\r\n        mounted(){\r\n            this.mashro = JSON.parse(this.mashro_data);\r\n            this.is_ready = true;\r\n            \r\n            this.setup_things();\r\n            this.load_data();\r\n            setTimeout(async ()=>{\r\n                var navText = [\r\n                        \"<i class='ri-arrow-left-line'></i>\",\r\n                        \"<i class='ri-arrow-right-line'></i>\",\r\n                ];\r\n                if(frappe.lang_dir == \"rtl\"){\r\n                    navText = [\r\n                        \"<i class='ri-arrow-right-line'></i>\",\r\n                        \"<i class='ri-arrow-left-line'></i>\",\r\n                    ];\r\n                }\r\n                $('#discover-slide').owlCarousel({\r\n                    items: 3,\r\n                    loop: false,\r\n                    rtl: frappe.lang_dir == \"rtl\",\r\n                    margin: 10,\r\n                    nav: true,\r\n                    dots: false,\r\n                    autoplay: true,\r\n                    smartSpeed: 1000,\r\n                    autoplayHoverPause: true,\r\n                    navText: navText,\r\n                    responsive: {\r\n                        0: {\r\n                            items: 2,\r\n                        },\r\n                        576: {\r\n                            items: 3,\r\n                        },\r\n                        768: {\r\n                            items: 3,\r\n                        },\r\n                        992: {\r\n                            items: 4,\r\n                        },\r\n                        1200: {\r\n                            items: 4,\r\n                        },\r\n                    },\r\n                });\r\n                $('.gallery-popup').each(function() {\r\n                    $(this).magnificPopup({\r\n                        delegate: 'a.gallery-image', \r\n                        type: 'image',\r\n                        gallery: {\r\n                            enabled:true\r\n                        }\r\n                    });\r\n                });\r\n\r\n                $('.popup-youtube, .popup-vimeo').magnificPopup({\r\n                    disableOn: 300,\r\n                    type: 'iframe',\r\n                    mainClass: 'mfp-fade',\r\n                    removalDelay: 160,\r\n                    preloader: false,\r\n                    fixedContentPos: false,\r\n                });\r\n            }, 500);\r\n        },\r\n        unmounted(){\r\n            window.removeEventListener(\"scroll\",this.handleScroll);\r\n        },\r\n\t\tmethods: {\r\n            setup_things: async function () {\r\n                var initial_lat = this.mashro.lat; \r\n                var initial_lng = this.mashro.lng;\r\n                let corner1 = L.latLng(31.896210012370656, 33.96066018865814);\r\n                let corner2 = L.latLng(17.613607036429755, 55.8301100044458);\r\n                var google_street_layer = L.tileLayer(\r\n                    \"https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}\",\r\n                    {\r\n                        maxZoom: 18,\r\n                        minZoom: 6,\r\n                        subdomains: [\"mt0\", \"mt1\", \"mt2\", \"mt3\"],\r\n                        attribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n                    }\r\n                );\r\n                var google_satellite_layer = L.tileLayer(\r\n                    \"https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}\",\r\n                    {\r\n                        maxZoom: 18,\r\n                        minZoom: 6,\r\n                        subdomains: [\"mt0\", \"mt1\", \"mt2\", \"mt3\"],\r\n                        attribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n                    }\r\n                );\r\n                var open_street = L.tileLayer(\r\n                    \"https://tile.openstreetmap.org/{z}/{x}/{y}.png\",\r\n                    {\r\n                        maxZoom: 18,\r\n                        minZoom: 6,\r\n                        attribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n                    }\r\n                );\r\n                this.mapsLayerGroup = new L.LayerGroup();\r\n                this.markerLayerGroup = new L.LayerGroup();\r\n                this.map = L.map(\"map\", {\r\n                    center: [initial_lat, initial_lng],\r\n                    zoom: 15,\r\n                    maxZoom: 18,\r\n                    minZoom: 10,\r\n                    dragging: false,\r\n                    maxBounds: L.latLngBounds(corner1, corner2),\r\n                    layers: [\r\n                        this.mapsLayerGroup,\r\n                        this.markerLayerGroup,\r\n                    ],\r\n                });\r\n                this.map.scrollWheelZoom.disable();\r\n                this.mapsLayerGroup.addLayer(open_street);\r\n\r\n                // this.map_marker = L.marker([initial_lat, initial_lng]);\r\n                // this.markerLayerGroup.addLayer(this.map_marker);\r\n                var baseLayers = frappe.lang_dir=='ltr'?{\r\n                    \"Map 1\": open_street,\r\n                    \"Map 2\": google_street_layer,\r\n                    \"Satellite\": google_satellite_layer,\r\n                }:{\r\n                    \"الخريطة 1\": open_street,\r\n                    \"الخريطة 2\": google_street_layer,\r\n                    \"القمر الصناعي\": google_satellite_layer,\r\n                };\r\n                var layerControl = L.control.layers(baseLayers).addTo(this.map);\r\n                latlng = L.latLng(initial_lat, initial_lng)\r\n\r\n                var geo_json = JSON.parse(this.mashro.location);\r\n                var polygon = L.geoJSON(geo_json,{\r\n                    onEachFeature:function (feature, layer) {\r\n                    }\r\n                }).on(\"click\", (e) => {\r\n                    window.open(\"/project/\"+mashro[\"name\"],\"_blank\");\r\n                });\r\n                this.mashro[\"marker\"] = polygon\r\n                this.mashro[\"marker\"][\"mashro\"] = this.mashro;\r\n                this.mashro[\"marker\"].addTo(this.map);\r\n\r\n            },\r\n            \r\n            check_local_storage: async function(){\r\n                this.page = await localStorage.my_catalogue_page?localStorage.my_catalogue_page:0;\r\n                this.end_of_page = localStorage.my_catalogue_end_of_page == 1?true:false;\r\n                this.properties = localStorage.my_catalogue_records?JSON.parse(localStorage.my_catalogue_records):[];\r\n                this.$forceUpdate(); \r\n            },\r\n            load_data: async function(reload=false){\r\n                if(this.is_loading)\r\n                    return;\r\n                if(reload){\r\n                    this.page = 0;\r\n                    this.end_of_page = false;\r\n                    while(this.properties.length > 0) {\r\n                        this.properties.pop();\r\n                    }\r\n                }\r\n                if(this.end_of_page)\r\n                    return;\r\n                global.emitter.emit(\"show-full-loading\");\r\n                this.is_loading = true;\r\n                let params = {\r\n                    'mashro_id': this.mashro.name,\r\n                    \"filters\":JSON.stringify(this.search_filters),\r\n                    \"page\":this.page\r\n                };\r\n                let url = \"/api/method/maalek.api.mashro_catalogue\";\r\n                let res = await $.ajax({\r\n                    url: url,\r\n                    type: \"GET\",\r\n                    data: params\r\n                });\r\n                if(res.message.length > 0){\r\n                    for (let index = 0; index < res.message.length; index++) {\r\n                        this.properties.push(res.message[index]);\r\n                    }\r\n                    this.page++;\r\n                }else{\r\n                    this.end_of_page = 1;\r\n                }\r\n                localStorage.my_catalogue_records = JSON.stringify(this.properties);\r\n                localStorage.user_catalogue_search_filters = JSON.stringify(this.search_filters);\r\n                localStorage.my_catalogue_page = this.page;\r\n                localStorage.my_catalogue_end_of_page = this.end_of_page?1:0;\r\n                this.is_loading = false;\r\n                global.emitter.emit(\"hide-full-loading\");\r\n            },\r\n            handleScroll: function (){\r\n                if(this.end_of_page){\r\n                    window.removeEventListener(\"scroll\",this.handleScroll);\r\n                }\r\n                if(this.loading || this.end_of_page)\r\n                    return;\r\n                let pagination_component = this.$refs[\"pagination_component\"];\r\n                if (pagination_component.getBoundingClientRect().bottom < window.innerHeight) {\r\n                    this.load_data();\r\n                }\r\n            }\r\n\t\t},\r\n\t\tcomputed:{\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n\r\n    #discover-slide.owl-theme .owl-nav {\r\n        position: unset;\r\n        top: -92px;\r\n        right: -5px;\r\n        margin-top: 0;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/single-mashro-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__